import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactPlayer from "react-player";

export default class ProductVideoPlayer extends Component {
  static propTypes = {
    url: PropTypes.string.isRequired,
  };

  render() {
    return <ReactPlayer url={this.props.url} width={"100%"} controls />;
  }
}
